import { TEST_IDS } from "modules/common";

import { ReactComponent as SmallerLogoIcon } from "../../assets/images/secondary-logo.svg";

export function Logo() {
  return <SmallerLogoIcon data-testid={TEST_IDS} width={60} height={28} />;
}
